import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'

const ActionLinks = ({
  continueShopping,
  links: [
    {
      displayName: viewCartText
    },
    {
      displayName: continueShoppingText
    }
  ],
  navigateToQuoteHandler
}) =>
  <Wrapper>
    <ViewQuoteBtn
      data-at-to-quote-button
      full="mobile"
      narrow
      onClick={ navigateToQuoteHandler }>
      { viewCartText }
    </ViewQuoteBtn>
    <ContinueShoppingBtn
      data-at-continue-shopping-button
      bolder
      full="mobile"
      stacked="mobile"
      link
      onClick={ continueShopping }>
      { continueShoppingText }
    </ContinueShoppingBtn>
  </Wrapper>

export default ActionLinks

ActionLinks.propTypes = {
  continueShopping: PropTypes.func,
  links: PropTypes.arrayOf(PropTypes.shape()),
  navigateToQuoteHandler: PropTypes.func
}

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '0 0 30px 0', ' 20px 0')}
  ${Mixin.responsive('margin-left', '165px', '0')}
`

const ViewQuoteBtn = styled(Button)`
  && {
    ${Mixin.font.GothamMedium()}
    background-color: ${Theme.colors.green};
    border: unset;
    border-radius: 60px;
  }
`

const ContinueShoppingBtn = styled(Button)`
  && {
    margin-left: 0;
  }
`
